module.exports = __webpack_public_path__ + "static/media/EphemeralFirelight.10865332.jpg";